import { Injectable } from '@angular/core';
import { url } from 'src/app/config/config';
import { map, filter } from 'rxjs/operators';
import {  Router, ActivationEnd } from '@angular/router';



@Injectable({
  providedIn: 'root'
})

export class TitleHeaderService {
  public myurl = url + "";


  constructor(
     
      private route: Router 
      ) {
  
   }
  
   changeHeaderTitle() {
    
    return this.route.events.
    pipe(
        filter( event => event instanceof ActivationEnd),
        filter( (event: ActivationEnd ) => event.snapshot.firstChild === null ),
        map( (event: ActivationEnd ) => event.snapshot.data )
    )
   }
 
  
}
